import backBtn from "../assets/icons/back-btn.png";
import logo from "../assets/doctio-logo.svg";
import fraseIkon from "../assets/icons/Paper-icon + circle.svg";
import sygeplejerske from "../assets/people/TBV03758.png";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Stats from "../components/Stats/Stats";

export default function Login() {
  const navigate = useNavigate();
  const [statsData, setStatsData] = useState({
    doctor: 0,
    medstudent: 0,
    nurse: 0,
    other: 0,
  });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isPasswordValid = password.trim() !== "";

  const handleLogin = async () => {
    if (!isEmailValid || !isPasswordValid) {
      toast.error("Vær venlig at udfylde alle felter");
      return;
    }

    try {
      const response = await fetch("https://test.doctio.dk/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      if (response.ok) {
        navigate("/fraser");
      } else {
        // Failed login
        toast.error("Tjek venligst at email og password er korrekt udfyldt.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("Der skete en fejl under login. Prøv igen senere.");
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          "https://test.doctio.dk/api/statistics/professions"
        );
        const jsonData = await response.json();
        setStatsData(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  return (
    <div>
      <section className="md:h-screen">
        <div className="grid mx-auto h-full md:grid-cols-2">
          <div className="bg-white container md:w-2/3 md:mx-auto md:py-6 order-2 md:order-1">
            <div className="header mt-2 hidden md:block flex items-center justify-between md:block">
              <button
                className="flex items-center md:mb-24"
                onClick={() => navigate(-1)}
              >
                <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
                <p className="text-doctio-green">Tilbage</p>
              </button>
              <img
                src={logo}
                width={150}
                className="md:mr-3 md:mb-20"
                alt="Logo"
              />
            </div>

            <h1 className="mt-10 md:mt-0 text-dxl font-bold leading-tight tracking-tight text-doctio-green md:text-d2xl">
              Log in
            </h1>

            <p>
              Har du ikke en bruger?{" "}
              <Link to="/signup" className="text-doctio-green underline">
                Opret gratis
              </Link>
            </p>
            <ToastContainer />
            <form
              className="space-y-4 mt-8 signup-form md:space-y-8"
              action="#"
            >
              <div>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="emaillogin"
                  className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  placeholder="Email"
                  required={true}
                />
              </div>
              <div className="mb-10">
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  required={true}
                />
              </div>
            </form>

            <button
              type="button"
              disabled={!isEmailValid || !isPasswordValid}
              style={{ opacity: isEmailValid && isPasswordValid ? 1 : 0.6 }}
              onClick={handleLogin}
              className="text-white transition-colors mt-10 mb-10 w-full duration-300 ease-in-out font-bold rounded-full bg-doctio-green hover:bg-white hover:text-doctio-green hover:shadow-md focus:ring-4 focus:outline-none px-4 py-4 text-center mr-3 md:mr-0"
            >
              Log in
            </button>

            <Link
              to="/forgotpassword"
              className="text-doctio-green underline italic"
            >
              Glemt password?
            </Link>
          </div>
          <div className="relative container md:max-w-none md:bg-doctio-lightgreen md:py-40 md:h-screen order-1 md:order-2 overflow-hidden">
            <div className="shadow-right"></div>
            <div className="md:w-2/3 md:mx-auto">
              <div className="image-container relative">
                <div className="header mt-4 mb-4 md:hidden flex items-center justify-between md:block">
                  <Link to="/">
                    <img
                      src={logo}
                      width={150}
                      className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                      alt="Logo"
                    />
                  </Link>
                  <button
                    className="flex items-center md:mb-8"
                    onClick={() => navigate(-1)}
                  >
                    <img
                      src={backBtn}
                      width={26}
                      className="mr-3"
                      alt="Tilbage"
                    />
                    <p className="text-doctio-green">Tilbage</p>
                  </button>
                </div>
                <img
                  src={sygeplejerske}
                  className="mr-3 h-96 object-cover md:h-auto w-full md:object-fit picture-shadow rounded-3xl"
                  alt="Sygeplejerske"
                />

                <div className="mt-12 mb-10 hidden md:block">
                  <p className="leading-tight tracking-tight">
                    <span className="font-bold">Navn Navnesen</span>, Titel lige
                    her, Hospitalsnavn.
                  </p>
                  <p className="mt-2 italic">Bruger af Doctio</p>
                </div>

                <div className="absolute hidden frase-ikon-sign md:block left-[-95px] top-[40%]">
                  <img
                    src={fraseIkon}
                    width={199}
                    className="mr-3"
                    alt="Fraseikon"
                  />
                </div>
              </div>
              <Stats data={statsData} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
